import type { Character } from './entities';

/** Returns true only on the frame a lit torch runs out. Applies to every free friend. */
export function drainFlashlight(c: Character, dt: number): boolean {
  if (!c.flashOn) return false;
  c.battery = Math.max(0, c.battery - dt / (240 * (c.def.trait.batteryMul ?? 1)));
  if (c.battery > 0) return false;
  c.flashOn = false;
  return true;
}
